import JSONAPISerializer from '@ember-data/serializer/json-api';

export default class ConversationSerializer extends JSONAPISerializer {
  keyForAttribute(attr) {
    return attr;
  }

  serialize() {
    let json = super.serialize(...arguments);

    if (json.data?.relationships?.person !== undefined) {
      delete json.data.relationships.person;
    }
    return json;
  }
}
